import { useBooleanFlag } from '@trm/feature-flags/web';

export const useBlockPurchaseFlag = () => ({
  useBlockPurchase: useBooleanFlag('block-all-purchases', false),
});
